import React from "react";

const MaintenanceNotice=()=>{
    return(
        <div id="maintenance">
    <section>
    <h1> Notice </h1>
<span>Our website is currently under maintenance. We apologize for missing information or any inconveniences you may have.</span>
    </section>
      <span id="exit-maintenance" onClick={()=>{
          let maintenance=document.getElementById("maintenance");
          maintenance.style.display="none";
      }}>  Close</span>
        </div>
    )
}
export default MaintenanceNotice;